import React from 'react';
import styled from 'styled-components';
import AnimateHeight from 'react-animate-height';
import {isMobileOnly, isIE} from 'react-device-detect';

const CateAnimateBlock = styled.div`

`;

const Cate1stItemBlock = styled.div`
    font-size: 16px;
    font-weight: normal;
    line-height: 1.5;
    color: ${props => props.color||'#111111'};
    cursor: pointer;
    position: relative;
    ::after {
        content: '';
        display: inline-block;
        width: 26px;
        height: 26px;
        background: ${props => props.isActive? 'url(/assets/images/icon/cate_minus.png)': 'url(/assets/images/icon/cate_plus.png)'}  center center/auto no-repeat;
        position: absolute;
        background-size: 26px 26px;
        
        right: 0px;
    }
`;

const Cate2ndItemBlcok = styled.span`
    //width: fit-content;
    position: relative;
    //display: inline;
    color: ${props => props.isActive ? '#111111' : '#666666'};
    font-size: 14px;
    line-height: 1.43;
    cursor: pointer;
    margin-left: 20px;
    
    &:after {
        content: '';
        display: block;
        position: absolute;
        width: ${props => props.isActive ? '100%' : '0%'};
        left: 0;
        bottom: ${props => props.bottom || '0px'};
        height: ${props => props.height || '1px'};
        //background-color: #79b88a;
        //background-color: ${isMobileOnly?"#111111":"#79b88a"};
        background-color: #111111;
        z-index: -1;
        -webkit-transition: width .2s ease-in;
        -o-transition: width .2s ease-in;
        transition: width .2s ease-in;
    }

    &:hover::after {
        width: 100%;
    }
`;

const CateAnimate = ({ click1handler, click2Handler, cateItem, active1stCateId, active2ndCateId }) => {


    const getActive = (id) => {
        
        if(active1stCateId*1 === cateItem.id*1 && active2ndCateId*1 === id*1) {
            return true;
        }

        return false;
    }

    const getOpen = () => {
        if(active1stCateId*1 === cateItem.id*1) {
            return true;
        }

        return false;
    }

    const handle2ndClick = (id) => {
        if(click2Handler !== null && click2Handler !== undefined) {
            click2Handler(id);
        }
    }

    const hand1stClick = () => {
        if(getOpen()) {
            return;
        }

        if(click1handler !== null && click1handler !== undefined) {
            click1handler(cateItem.id);
        }
    }

    if(cateItem === null && cateItem === undefined) {
        return <div/>
    }

    return (      
        <CateAnimateBlock className={getOpen()? "margin_b-30":"margin_b-20"} >
            <Cate1stItemBlock color={getOpen()? "#fd683a":"#111111"} isActive={getOpen()} onClick={hand1stClick}>
                {cateItem.cate_name}
            </Cate1stItemBlock>
            <AnimateHeight duration={300} height={(getOpen() ? 'auto' : '0%')} className="clearfix">
                <div className="margin_t-20 margin_b-20">
            <Cate2ndItemBlcok key={-1} isActive={getActive(0)} onClick={()=>{handle2ndClick(0)}}>
                            전체
            </Cate2ndItemBlcok>
            </div>
            {
                cateItem.cate2.map((curitem, idx) => {
                    return (<div className="margin_b-20" key={idx} >
                        <Cate2ndItemBlcok key={idx} isActive={getActive(curitem.id)} onClick={()=>{handle2ndClick(curitem.id)}}>
                            {curitem.cate_name}
                        </Cate2ndItemBlcok>
                        </div>
                    );
                })
            }
            </AnimateHeight>
        </CateAnimateBlock>
    );
};

export default CateAnimate;